import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

export const AuthenticationGuardService: CanActivateFn = (route, state) => {

  const oauthService = inject(AuthService);

    if (!oauthService.hasValidAccessToken()) {
      oauthService.authorize();
      return true;    
    }
    else{
      return true;
    }
}
